import React, { useEffect } from 'react';
import ManageEntityList from './ManageEntityList';
import entities from '../../utils/entities';
import { useAuth } from '../../Services/AuthContext';
import { useState } from 'react';
import { Route } from 'react-router-dom';
import Editor from '../Models/Editor';




const TimeLine = ({ type, clientCol, charterRequestCol, supplierCol, item, route, parentHeight }) => {
    const [auth] = useAuth();
    const [cols, setCols] = useState();
    useEffect(() => {
        if (!cols) {
            let columns = [...entities.timeline.columns];

            if (clientCol) {
                columns.push(entities.timeline.clientColumn);
            }
            if (charterRequestCol) {
                columns.push(entities.timeline.charterColumn);
            }
            columns.push({ accessor: 'user.email', Header: 'User', sortNoCase: true });

            if (auth.role === 'Admin') {

                columns.push(entities.timeline.supplierColumn);
            }

            setCols(columns);
        }
    }, [cols, auth.role, charterRequestCol, clientCol])
    const entity = {
        ...entities.timeline,
        columns: cols,
        getByStatus: () => entities.timeline.getByStatus({ type: type, id: item?.id })

    };

    return cols ? <React.Fragment>
        <ManageEntityList hideActions item={item} route={route + '/Timeline'} parentHeight={parentHeight} entity={entity} headerHeight={0} />
        <Route path={route + '/changeCharter/:changeCharterId'} render={({ match }) =>
            <Editor route={route} entity={entities.changeCharter} itemId={match.params.changeCharterId} />} />
    </React.Fragment>
        : null;
}
export default TimeLine;
